<template>
  <div :class="[$style.container, message && $style.containerActive]">
    <div :class="$style.left">
      <button :class="$style.cancel" @click="$emit('cancel')">Отмена</button>
    </div>
    <div :class="$style.right">
      <!--      <app-button class="ml-2" type="border" @click="onEdit" icon="PenIcon" size="small">Редактировать</app-button>-->
      <vs-tooltip
        text="Удаление доступно для последнего сообщения или в течение 10 минут с момента отправки"
        :active="!canDelete"
      >
        <app-button class="ml-2" type="border" @click="onDelete" icon="TrashIcon" size="small" :disabled="!canDelete">
          Удалить
        </app-button>
      </vs-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name:     "ChatSelectedMessageActions",
  props:    ['message', 'isMessageLast'],
  data() {
    return {
      canDelete: false,
    };
  },
  computed: {
    currentUserId() {
      return this.$store.getters['appUser/id'];
    },
  },
  methods:  {
    onDelete() {
      this.$modal.openConfirm({ message: 'Вы действительно хотите удалить сообщение?' }).result
        .then(() => this.$emit('delete'));
    },

    isCanDelete( message ) {
      if (!message) return false;
      if (this.currentUserId !== message.users_id) return false;

      if (this.isMessageLast) return true;

      let itemDate = new Date(message.created_at);
      let nowDate = Date.now();
      let minutes = (nowDate - itemDate) / 60000;
      if (minutes > 10) return false;

      return true;
    },
  },
  watch:    {
    message( message ) {
      this.canDelete = this.isCanDelete(message);
    },
    isMessageLast() {
      this.canDelete = this.isCanDelete(this.message);
    }
  },
};
</script>

<style lang="scss" module>
.container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  border-bottom: 1px solid #A9A9A9;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 20px;
  transform: translateY(-100%);
  //opacity: 0;
  @include anim(.1s);
}

.containerActive {
  transform: none;
  //opacity: 1;
}

.cancel {
  background: transparent;
  border: 0;
  opacity: .6;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
  @include anim();

  &:hover {
    opacity: 1;
  }
}

.right {
  margin-left: auto;
}
</style>
